// .\client\src\components\Admin\AuditLog.jsAuditLog.js
import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";
import { useNavigate } from "react-router-dom";
import { Input, Select } from "../../components/workspace";

function AuditLog() {
	const ADMIN_USERS = 1; // the lower the number the more privilages

	const { auditLog, loadMainRecords, employees, toggleReviewForm, user } = useAppContext();

	const [selectedRow, setSelectedRow] = useState(null);

	const [filters, setFilters] = useState({
		search: "",
		jobType: "default",
		jobStatus: "default",
	});

	const navigate = useNavigate();

	const resetFilters = () => {
		setFilters({
			search: "",
			jobType: "default",
			jobStatus: "default",
		});
	};

	const filterResults = (newFilters) => {
		if (!auditLog) {
			return;
		}
		let filtered = auditLog;
		// filter results
		filtered = filtered?.filter((logObject) => {
			const { path, user_roles_id, new_data, old_data } = logObject;
			// build lowercase variables for an easy case agnostic search
			const procFilter = newFilters.search?.toLowerCase();
			const pathSearch = path?.toLowerCase();
			const userSearch = user_roles_id?.toLowerCase();
			const newDataSearch = JSON.stringify(new_data)?.toLowerCase();
			const oldDataSearch = JSON.stringify(old_data)?.toLowerCase();
			let match = false;
			// check the search input text for matches
			if (
				pathSearch?.includes(procFilter) ||
				userSearch?.includes(procFilter) ||
				newDataSearch?.includes(procFilter) ||
				oldDataSearch?.includes(procFilter)
			) {
				match = true;
			}

			return match;
		});
		return filtered;
	};

	const handleInput = (e, number) => {
		const name = e.target.name;
		const value = number ? Number(e.target.value) : e.target.value;
		setFilters({
			...filters,
			[name]: value,
		});
		filterResults({
			...filters,
			[name]: value,
		});
	};

	const selectRow = async (e, jobId) => {
		console.log("e.target.parentNode.className:", e.target.parentNode.className);
		if (
			e.target.parentNode.className === "selected" ||
			e.target.parentNode.parentNode.className === "selected"
		) {
			// loadMainRecords(jobId);
			// navigate("../job-summary");
		}
		setSelectedRow(jobId);
	};

	const handleSubmit = (e) => {
		e.preventDefault();
	};

	const reviewJob = (selectedJob) => {
		console.log("selectedJob:", selectedJob);

		toggleReviewForm(selectedJob);
	};

	const ReviewButton = ({ record }) => {
		// Start by finding basic job status
		let statusCell = "";
		// Conditionally include the Review Job button if job is In Review and the user is an admin
		if (user.user_roles_id < ADMIN_USERS && record.job_status_id === 15) {
			statusCell = (
				<button className="btn" type="button" onClick={() => reviewJob(record)}>
					Review Job
				</button>
			);
		}

		return statusCell;
	};

	return (
		<form className="form" onSubmit={handleSubmit}>
			<h3>Recent Database Changes</h3>
			<div className="form-center">
				{/* Search bar and clear filters button */}
				{/*<div className="one-half flex-parent">
					<button className="btn red" type="button" onClick={resetFilters}>
						Clear Filters
					</button>
					<div className="one-half">
						<Input
							type="text"
							name="search"
							value={filters.search}
							handleChange={(e) => handleInput(e)}
						/>
					</div>
				</div>*/}
				{/* ------- All Jobs Table -------- */}
				<div className="table whole admin-log">
					<table>
						<thead>
							<tr>
								<th style={{ width: 170 }}>Time</th>
								<th style={{ width: 100 }}>Job Number</th>
								<th style={{ width: 180 }}>Path</th>
								<th style={{ width: 124 }}>User</th>
								<th style={{ width: 80 }}>Ip Address</th>
								<th style={{ width: 210 }}>Agent</th>
								<th>New Data</th>
								<th>Old Data</th>
							</tr>
						</thead>
						<tbody>
							{/* Loop through each job to build row data */}
							{filterResults(filters)?.map((record, index) => {
								const user = employees?.filter((emp) => emp.id === record.user_id)[0]?.full_name;
								const date = new Date(record.created_at);
								const displayDate = date.toLocaleString("en-US", {
									month: "short",
									day: "numeric",
									year: "numeric",
									hour: "2-digit",
									minute: "2-digit",
								});
								return index < 40 ? (
									<tr
										key={record.id}
										className={selectedRow === record.id ? "selected" : ""}
										onClick={(e) => selectRow(e, record.id)}
									>
										<td>{displayDate}</td>
										<td>{}</td>
										<td>{record.path}</td>
										<td>{user}</td>
										<td>{record.ip_address}</td>
										<td>{record.user_agent}</td>
										<td>
											<div className="json-cell" style={{ color: "green" }}>
												{JSON.stringify(record.new_data, null, 2).slice(1, -1).trim()}
											</div>
										</td>
										<td>
											<div className="json-cell" style={{ color: "red" }}>
												{JSON.stringify(record.old_data, null, 2).slice(1, -1).trim()}
											</div>
										</td>
									</tr>
								) : (
									""
								);
							})}
						</tbody>
					</table>
				</div>
			</div>
		</form>
	);
}
export default AuditLog;
